<template>
  <!-- Alternância entre licenças de Pacientes e de Profissionais.
       É uma troca interna da tela de Licenças (não navega para outra página). -->
  <div class="license-tabs">
    <button
      type="button"
      class="license-tab"
      :class="{ active: modelValue === 'patients' }"
      @click="$emit('update:modelValue', 'patients')"
    >
      Pacientes
    </button>
    <button
      type="button"
      class="license-tab"
      :class="{ active: modelValue === 'professionals' }"
      @click="$emit('update:modelValue', 'professionals')"
    >
      Profissionais
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: "patients",
      validator: (value) => ["patients", "professionals"].includes(value)
    }
  },
  emits: ["update:modelValue"]
};
</script>

<style lang="scss" scoped>
$lila-primary: #4f3f82;
$lila-accent: #9a397d;

.license-tabs {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #ffffff;
  border: 1px solid #eceaf3;
  border-radius: 999px;
  padding: 4px;
  margin-bottom: 22px;
}

/* Cada aba abraça o próprio texto; a ativa recebe o fundo magenta. */
.license-tab {
  border: none;
  background: transparent;
  color: $lila-primary;
  font-size: 15px;
  font-weight: 600;
  padding: 9px 28px;
  border-radius: 999px;
  cursor: pointer;
  white-space: nowrap;
  text-align: center;
  transition: background 0.25s ease, color 0.25s ease;
}

.license-tab.active {
  background: $lila-accent;
  color: #ffffff;
}
</style>
